"use client";
import { AnalyticsProvider } from "@lib/analytics/AnalyticsProvider";
import {
    PageMicrocopyProvider,
    type PageMicrocopySets,
} from "@lib/contentful/microcopy/MicrocopyContext";
import dynamic from "next/dynamic";
import type { ComponentType } from "react";
import { isProduction } from "@config/site/helpers";

let Backstage: ComponentType | null = null;
if (!isProduction) {
    Backstage = dynamic(() => import("@lib/monitoring/site-info-tooltip/Backstage"), {
        // For some reason setting this to false breaks SSR
        ssr: true,
    });
}
type PageContentProps = Readonly<{
    children: React.ReactNode;
    pageType: string;
    microcopySets?: PageMicrocopySets;
}>;

export default function PageContent({
    children,
    microcopySets = { page: {} },
    pageType,
}: PageContentProps) {
    return (
        <AnalyticsProvider pageType={pageType}>
            <PageMicrocopyProvider microcopySets={microcopySets}>
                {Backstage ? <Backstage /> : null}
                {children}
            </PageMicrocopyProvider>
        </AnalyticsProvider>
    );
}
